import { render, staticRenderFns } from "./WCompanyEdit.vue?vue&type=template&id=9d633c64&"
import script from "./WCompanyEdit.vue?vue&type=script&lang=ts&"
export * from "./WCompanyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports